/**
 * Alert Banner
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'alert-banner-new';

class AlertBanner extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        body: document.body,
        container: this.element.querySelector(`.${componentName}__container`),
        closeButton: this.element.querySelector(`.${componentName}__close`)
    };

    // Util & State
    alertEvent = new CustomEvent('rockwell-alert', null);

    /**
     * Disable Alert Banner
     */
    disableAlert = () => {
        this.element.classList.add('alert-banner-new__hidden');

        window.dispatchEvent(this.alertEvent);
    };

    /**
     * Enable Alert Banner
     */
    enableAlert = () => {
        window.dispatchEvent(this.alertEvent);
    };

    /**
     * Close Alert Banner
     */
    closeAlert = () => {
        this.disableAlert();
        window.dispatchEvent(new CustomEvent('rockwell-alert-showhide', null));
    };

    /**
     * Add Event Listeners
     */
    addEventListeners = () => {
        this.elements.closeButton.addEventListener('click', this.closeAlert);
    };

    /**
     * Initialize Component
     */
    init() {
        this.enableAlert();
        this.addEventListeners();
    }
}

registerComponent(`.${componentName}`, AlertBanner);
